import App from './components/App.vue'
import { store, dataStore } from './../client/stores'
import { vueRouter } from './router'
import i18n from './../client/i18n'

export default {
  elementId: 'client_embed',
  rootComponent: App,
  vueRouter,
  stores: [
    {
      key: ['ClientEmbed'],
      module: store
    }
  ],
  i18n,
  // Vuetify is now configured globally in application.ts
  data: {
    dataStore: dataStore
  }
}
